import "./AddData.css"
import { useContext, useEffect, useRef, useState } from "react";
import axios from 'axios';
import Tooth from "../assets/tooth.png";
import { useNavigate } from "react-router-dom";
import { BsPersonFillAdd } from "react-icons/bs";
import { loginkey } from "./LoginContext";
import LogIn from "./login";
import { useMediaQuery } from "react-responsive";
import { FaRegSave } from "react-icons/fa";
import { IoMdArrowRoundBack } from "react-icons/io";
import { AddDetailsContext } from "./AddDetailsContext";
import { loginUserId } from "./LoginUserIdContext";

function AddData(props) {
    const inputRef = useRef(null);
    const [name, setName] = useState("");
    const [age, setAge] = useState("");
    const [sex, setSex] = useState("Male");
    const [phone, setPhone] = useState("");
    const [file, setFile] = useState();
    const [notes, setNotes] = useState("");
    const [infoo, setInfoo] = useState([]);
    const [uploadMessage, setUploadMessage] = useState('');
    const [enable, setEnable] = useState(null);
    const { auth } = useContext(loginkey);
    const { id } = useContext(loginUserId)
    const { setAddDetailsContextt } = useContext(AddDetailsContext)
    const domainUrl = "drclinic.hassan-mohammad.tech"


    const handleNameChange = (e) => {
        setName(e.target.value);
    };
    const handleAgeChange = (e) => {
        setAge(e.target.value);
    };
    const handleSexChange = (e) => {
        setSex(e.target.value);
    };
    const handlePhoneChange = (e) => {
        setPhone(e.target.value);
    };
    const handleNotesChange = (e) => {
        setNotes(e.target.value);
    };
    function handleFileChange(event) {
        setFile(event.target.files[0])
    }

    function handleAxiosSubmit(event) {
        event.preventDefault();
        setEnable(true);
        setUploadMessage('Loading...')
        const url = `https://${domainUrl}/php/addPatients.php`;
        const formData = new FormData();
        formData.append('name', name);
        formData.append('age', age);
        formData.append('sex', sex);
        formData.append('phone', phone);
        formData.append('notes', notes);
        formData.append('loginuserid', id);
        formData.append('bookFile', file);
        const config = {
            headers: {
                "Content-Type": "text/html",
                "charset": "utf-8"
            },
        };
        axios.post(url, formData, config).then(response => {
            if (response.status === 200) {
                setUploadMessage("Done")
                setEnable(false)
                navToGet();
            }
        })
            .catch(error => {
                setUploadMessage(error.message)
            });
    }

    const navigate = useNavigate();
    function navToGet() {
        window.history.pushState({ id: 1 }, null, "GetPatients")
        navigate("/GetPatients", { replace: true });
    }
    console.log(`loginuseriddAdd ${id}`)
    console.log(props.verfied)
    function back() {
        window.history.pushState({ id: 1 }, null, "GetPatients")
        navigate("/GetPatients", { replace: true });
    }
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1224px)'
    })
    const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
    console.log(file)
    useEffect(() => {
        setAddDetailsContextt(true);
    }, [])
    /*useEffect(()=>{
        window.history.pushState({id:1},null,"AddPatients")
    },[])*/
    return (
        <div className="add">
            {auth == 1 && <div>{isDesktopOrLaptop && <div className="container-add">
                <form className="add-form" onSubmit={handleAxiosSubmit}>
                    <img src={Tooth} className="tooth-img"></img>
                    <div className="title-add">Add Patient<BsPersonFillAdd /></div>
                    <input type="text" className="form-control form-input" onChange={(event) => handleNameChange(event)} placeholder="Name" required></input>
                    <input type="number" className="form-control form-input" onChange={(event) => handleAgeChange(event)} placeholder="Age" required maxLength={3}></input>
                    <select typeof="select" className="form-select form-input" value={sex} onChange={(event) => handleSexChange(event)} required>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </select>
                    <input type="number" className="form-control form-input form-input-phone" onChange={(event) => handlePhoneChange(event)} placeholder="Phone" required maxLength={11}></input>
                    <textarea type="text" className="form-control form-input-area" onChange={(event) => handleNotesChange(event)} placeholder="Notes" required></textarea>
                    <input ref={inputRef} type="file" className="form-control" id="bookFile" name="myfile" key="bookFile" placeholder="Add File"
                        onChange={handleFileChange} multiple></input>
                    <div className="btn-container">
                        {uploadMessage && <div className="label-text">{uploadMessage}</div>}
                        <button type="submit" className="btn btn-success add-button">Add</button>
                        <button className="btn btn-dark add-button" onClick={back}>Back</button>
                    </div>
                </form>
            </div>
            }
            </div>}
            {auth == 1 && <div>{isTabletOrMobile && <div className="container-add-mobile">
                <form className="add-form-mobile" onSubmit={handleAxiosSubmit}>
                    <img src={Tooth} className="tooth-img-mobile"></img>
                    <input type="text" className="form-control form-input-mobile" onChange={(event) => handleNameChange(event)} placeholder="Name" required></input>
                    <input type="number" className="form-control form-input-mobile" onChange={(event) => handleAgeChange(event)} placeholder="Age" required maxLength={3}></input>
                    <select typeof="select" className="form-select form-input-mobile" value={sex} onChange={(event) => handleSexChange(event)} required>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </select>
                    <input type="number" className="form-control form-input-mobile form-input-phone" onChange={(event) => handlePhoneChange(event)} placeholder="Phone" required maxLength={11}></input>
                    <textarea type="text" className="form-control form-input-area-mobile" onChange={(event) => handleNotesChange(event)} placeholder="Notes" required></textarea>
                    <input ref={inputRef} type="file" className="form-control form-input-mobile" id="bookFile" name="myfile" key="bookFile" placeholder="Add File"
                        onChange={handleFileChange} multiple></input>
                    <div className="btn-container-mobile">
                        {uploadMessage && <div className="label-text">{uploadMessage}</div>}
                        <button type="submit" className="btn btn-success add-button-mobile">Add</button>
                        <button className="btn btn-dark add-button-mobile" onClick={back}>Back</button>
                    </div>
                </form>
            </div>}
            </div>}
            {auth == 0 && <LogIn />}
        </div>
    );
}

export default AddData;